import { TFunctionType } from 'shared/entities/localization';

import { IRootStore } from '../../store/rootStore';
import {
  ActualNameCreator,
  createActualBlockName,
  normalizeCommonFields
} from '../../block/common';

import {
  ConditionIsGroupMemberNormalizer,
  IConditionIsGroupMemberParams
} from './client';

const createConditionIsGroupMemberActualNameBase = (
  channelId: string | null,
  rootStore: IRootStore,
  t: TFunctionType
): string => {
  if (!channelId) {
    return t('block.ConditionIsGroupMember.actualName.hasNoChannelId', {
      ns: 'entities'
    });
  }

  const groupName = rootStore.channelsStore.channels.getEntity(channelId)?.name;

  return t('block.ConditionIsGroupMember.actualName.hasChannelId', {
    ns: 'entities',
    groupName
  });
};

export const createConditionIsGroupMemberActualName: ActualNameCreator<
  IConditionIsGroupMemberParams
> = ({ params, rootStore, t }) =>
  createConditionIsGroupMemberActualNameBase(
    params.channelId.value,
    rootStore,
    t
  );

export const normalizeConditionIsGroupMember: ConditionIsGroupMemberNormalizer =
  (raw, stores) => {
    return {
      ...normalizeCommonFields(raw, stores),
      actualName: (t) =>
        createActualBlockName({
          paramsName: createConditionIsGroupMemberActualNameBase(
            raw.params.channel_id,
            stores.rootStore,
            t
          ),
          blockKind: raw.kind,
          blockName: raw.name,
          t,
          ...stores
        })
    };
  };
